import { render, staticRenderFns } from "./SpiderChartForm.vue?vue&type=template&id=21872576&"
import script from "./SpiderChartForm.vue?vue&type=script&lang=js&"
export * from "./SpiderChartForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports